import React from "react"


import './style.scss'

type StepperProps = {
  stepList: {
    value: string,
    label?: string,
    description?: string,
    content: () => {},
  }[],
  activeValue: string,
}

export const Stepper = (props: StepperProps) => {

  const {stepList, activeValue} = props
  const activeIndex = stepList.findIndex(el => el.value === activeValue)
  const activeNode = stepList.find(el => el.value === activeValue)

  return <div className="stepper-container">
    <ol className="step-container" aria-label="Étapes de traitement">
      {stepList?.map((step, index) => {
        const {value} = step
        const state = index < activeIndex ? "complete" : index === activeIndex ? "active" : "upcoming"
        return <li className={`step step-${state}`} key={`step_${value}`} aria-current={state === "active" ? "step" : undefined}>
          <span className="step-marker" aria-hidden="true">
            {state === "complete" ? <span className="fas fa-check"></span> : <span>{index + 1}</span>}
          </span>
          <span className="step-copy">
            <strong>{step.label || value}</strong>
            {step.description && <small>{step.description}</small>}
          </span>
        </li>
      })}
    </ol>
    <section className="content-container">
      {activeNode && activeNode.content()}
    </section>
  </div>
}
